import useQueryBuildings from "ApiLayer/Building/queryBuildings";
import { Paragraph } from "components/atoms/Typography";
import { useBuildingBarChartAndMapByProperty } from "queries/Reports/Baseline/useBuildingBarChartAndMapByProperty";
import useCurrentFilterset from "queries/Reports/Baseline/useCurrentFilterset";

interface NumberOfBuildingsProps {
    groupByMetric: GroupByMetric;
}

function NumberOfBuildings({ groupByMetric }: NumberOfBuildingsProps) {
    const { reportedVsPublishedState, selectedFiltersetUid, isLoading: isLoadingFilterset } = useCurrentFilterset();

    const { data: buildingsResponse, isLoading: isLoadingBuildings } = useQueryBuildings(
        selectedFiltersetUid,
        reportedVsPublishedState
    );

    // TODO: just count the number of distinct properties in the buildingsResponse, instead of using this query
    const { data: properties, isLoading: isLoadingProperties } =
        useBuildingBarChartAndMapByProperty(selectedFiltersetUid);

    if (isLoadingBuildings || isLoadingProperties || isLoadingFilterset) {
        return <div className="number-of-buildings" />;
    }

    const numberOfGroups = groupByMetric === "property" ? properties!.length : buildingsResponse!.buildings.length;

    return (
        <div className="number-of-buildings">
            <Paragraph style={{ color: "var(--audette-gray-500)" }}>
                {numberOfGroups} {groupByMetric === "property" ? "properties" : "buildings"}
            </Paragraph>
        </div>
    );
}

export default NumberOfBuildings;
